import React from 'react';
// import OwnerModal from './OwnerModal';
import { Box } from '@material-ui/core';
import ClientGrid from '../../../components/ClientGrid/ClientGrid';

export default function SubAccountTable({
  accountId,
  list: rows,
  set: setRows,
  importMode: isImport,
}) {
  const columns = [
    {
      id: 'customerType',
      field: 'customerType',
      label: 'Customer Type',
    },
    {
      id: 'description',
      field: 'description',
      label: 'Description',
    },
  ];

  const getCsvData = async () => {
    if (rows.length === 0) {
      return [];
    }
    let rowsCopy = [...rows];
    return rowsCopy;
  };

  return (
    <div className="page-c" style={{ marginTop: -50 }}>
      <Box component="search-c">
        <div className="grd-row nm">
          <div className="grd-cell-none">
            {/* <Button
              type="plus"
              label="Add New Sub Account"
              onClick={() => {
                handleOpen();
              }}
            /> */}
          </div>
        </div>
      </Box>
      <div className="mt-20">
        <ClientGrid
          title="Customer Type"
          rowIdField="customerTypeId"
          columns={columns}
          rows={rows}
          getCsvData={getCsvData}
          setRows={setRows}
        />
      </div>
    </div>
  );
}
